var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8753C0 5.35241 4.47715 0.875244 10 0.875244H42C47.5228 0.875244 52 5.3524 52 10.8752V43.8647C52 49.3875 47.5228 53.8647 42 53.8647H10C4.47715 53.8647 0 49.3875 0 43.8647V10.8753Z",
    fill: "url(#paint0_linear_44_1532)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 41.7213H30.875C38.1666 41.7213 41.0833 38.7491 41.0833 31.3187V22.4022C41.0833 14.9718 38.1666 11.9996 30.875 11.9996H22.125C14.8333 11.9996 11.9166 14.9718 11.9166 22.4022V31.3187C11.9166 38.7491 14.8333 41.7213 22.125 41.7213Z",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 26.1323L26.5 30.5906L30.875 26.1323",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 30.5906V18.7019",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 33.5627C23.4229 35.4946 29.5771 35.4946 35.25 33.5627",
    stroke: "white",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1532",
    x1: 26,
    y1: 0.875244,
    x2: 26,
    y2: 53.8647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13DA9E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInst);
export default __webpack_public_path__ + "static/media/iconInst.a7d488779512a722418a25ed8e974b23.svg";
export { ForwardRef as ReactComponent };